
import { 
  AppManager,
  AnalyticsManager, 
} from '@common';
import "../styles/embeddedImage.scss";
import $ from "jquery";

export const tag = `
<div class="wrapper-inmodal">
  <div class="container">
    <div class="content-image"></div>
  </div>
</div>
`.trim();

export function init(modal, context, image, link = null) {
  const wrapperElement = $(".wrapper-inmodal", modal);
  const imgElement = $(`<img src="${image}"></img>`).appendTo(
    $(".content-image", wrapperElement)
  );
  if (link) {
    $(`<button class="link"><img src="${AppManager.convertToLocalizedPath(link.image)}"></img></button>`)
      .appendTo($(".content-image", wrapperElement))
      .on("click", function () {
        //context.popupManager.reopenImage(link.to);

        context.popupManager.openVideo(link.popup_video, null,
          () => {
            AnalyticsManager.sendVideo(link.popup_video.content, 'playedVideoEndByButtonOnPopup');
          });  
        AnalyticsManager.sendVideo(link.popup_video.content, 'playByButtonOnPopup');        
      });
  }
}